module.exports = __webpack_public_path__ + "img/alert7.a907e58f.png";